import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="plan-calculator"
export default class extends Controller {
  static targets = ["creditsSection", "suggestions", "suggestionText"]

  connect() {
    this.togglePlanType()
  }

  togglePlanType() {
    const unlimitedRadio = this.element.querySelector('input[name="membership_plan[unlimited_classes]"][value="true"]')
    const isUnlimited = unlimitedRadio?.checked

    if (this.hasCreditsSectionTarget) {
      this.creditsSectionTarget.style.display = isUnlimited ? 'none' : 'block'
    }

    this.calculatePrice()
  }

  calculatePrice() {
    const price = parseFloat(this.element.querySelector('input[name="membership_plan[price]"]')?.value) || 0
    const credits = parseInt(this.element.querySelector('input[name="membership_plan[credits_per_cycle]"]')?.value) || 0
    const unlimitedRadio = this.element.querySelector('input[name="membership_plan[unlimited_classes]"][value="true"]')
    const isUnlimited = unlimitedRadio?.checked

    if (!this.hasSuggestionTextTarget) return

    if (isUnlimited) {
      this.suggestionTextTarget.textContent = `Perfect! Unlimited plans are popular for committed members. Average: $1,500 MXN/month`
    } else if (credits && price) {
      const pricePerClass = price / credits
      this.suggestionTextTarget.textContent = `$${pricePerClass.toFixed(2)} per class. Market average for ${credits}-class packs: $${(credits * 100).toFixed(0)} - $${(credits * 150).toFixed(0)} MXN`
    } else {
      this.suggestionTextTarget.textContent = `Enter your pricing details to see recommendations`
    }
  }

  applyTemplate(event) {
    const template = event.currentTarget.dataset.template
    const nameInput = this.element.querySelector('input[name="membership_plan[name]"]')
    const priceInput = this.element.querySelector('input[name="membership_plan[price]"]')
    const cycleSelect = this.element.querySelector('select[name="membership_plan[billing_cycle]"]')
    const creditsInput = this.element.querySelector('input[name="membership_plan[credits_per_cycle]"]')
    const descInput = this.element.querySelector('textarea[name="membership_plan[description]"]')
    const unlimitedRadio = this.element.querySelector('input[name="membership_plan[unlimited_classes]"][value="true"]')
    const creditBasedRadio = this.element.querySelector('input[name="membership_plan[unlimited_classes]"][value="false"]')

    const templates = {
      'unlimited': {
        name: 'Unlimited Monthly',
        price: 1500,
        cycle: 'monthly',
        unlimited: true,
        description: 'Unlimited access to all classes'
      },
      '8-pack': {
        name: 'Basic 8 Pack',
        price: 800,
        cycle: 'monthly',
        unlimited: false,
        credits: 8,
        description: '8 classes per month'
      },
      '12-pack': {
        name: 'Premium 12 Pack',
        price: 1100,
        cycle: 'monthly',
        unlimited: false,
        credits: 12,
        description: '12 classes per month'
      },
      'drop-in': {
        name: 'Drop-In Single Class',
        price: 150,
        cycle: 'one_time',
        unlimited: false,
        credits: 1,
        description: 'Single class pass'
      }
    }

    const config = templates[template]
    if (!config) return

    if (nameInput) nameInput.value = config.name
    if (priceInput) priceInput.value = config.price
    if (cycleSelect) cycleSelect.value = config.cycle
    if (descInput) descInput.value = config.description

    if (config.unlimited) {
      if (unlimitedRadio) unlimitedRadio.checked = true
    } else {
      if (creditBasedRadio) creditBasedRadio.checked = true
      if (creditsInput) creditsInput.value = config.credits
    }

    this.togglePlanType()
  }

  addFeature(event) {
    const container = document.getElementById('features-container')
    if (!container) return

    const html = `
      <div class="flex gap-2">
        <input type="text"
               name="membership_plan[features][]"
               placeholder="Feature"
               class="flex-1 px-3 py-3 sm:py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-base sm:text-sm">
        <button type="button"
                data-action="click->plan-calculator#removeFeature"
                class="px-3 py-3 sm:py-2 text-gray-400 hover:text-red-600 transition">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
        </button>
      </div>
    `
    container.insertAdjacentHTML('beforeend', html)
  }

  removeFeature(event) {
    const featureRow = event.currentTarget.closest('.flex.gap-2')
    if (featureRow) {
      featureRow.remove()
    }
  }
}
